import { format } from "date-fns";
import React from "react";
import {
  Employee,
  Material,
  WorkDayMaterialRequirement,
} from "../../api/generated";

export type ImportTableEmployee = Employee & {
  materials: WorkDayMaterialRequirement[];
};

interface EmployeeImportTableProps {
  materials: Material[];
  employees: ImportTableEmployee[];
  itemsPerPage: number;
}

const determinePageNumbers = (
  totalItems: number,
  itemsPerPage: number,
): number[] => {
  const pageNumbers: number[] = [];

  for (let i = 1; i <= Math.ceil(totalItems / itemsPerPage); i++) {
    pageNumbers.push(i);
  }

  return pageNumbers;
};

export const EmployeeImportTable = (props: EmployeeImportTableProps) => {
  const totalPages = determinePageNumbers(
    props.employees.length,
    props.itemsPerPage,
  );
  const [currentPage, setCurrentPage] = React.useState(0);

  return (
    <div>
      <h3 className="text-lg font-bold mt-4">
        Medewerkers ({props.employees.length})
      </h3>
      <div className="overflow-x-auto">
        <table className="table table-zebra table-xs w-full">
          <thead>
            <tr>
              <th>Naam</th>
              <th>Voornaam</th>
              <th>Geboortedatum</th>
              <th>Rol</th>
              <th>Coördinator</th>
              {props.materials.map((material) => (
                <th key={material.name}>{material.name}</th>
              ))}
            </tr>
          </thead>
          <tbody>
            {props.employees
              .slice(
                currentPage * props.itemsPerPage,
                (currentPage + 1) * props.itemsPerPage,
              )
              .map((employee, index) => (
                <tr key={index}>
                  <td>{employee.lastName}</td>
                  <td>{employee.firstName}</td>
                  <td>{format(employee.birthDate, "yyyy-MM-dd")}</td>
                  <td>{employee.role}</td>
                  <td>{employee.coordinator}</td>
                  {employee.materials.length === 0 && (
                    <td
                      colSpan={props.materials.length}
                      className="text-center"
                    >
                      Geen materialen
                    </td>
                  )}

                  {employee.materials.length > 0 &&
                    employee.materials.map((material) => (
                      <td key={material.material.name}>
                        {material.requiredQuantity === 0
                          ? ""
                          : material.requiredQuantity}
                      </td>
                    ))}
                </tr>
              ))}
          </tbody>
        </table>
        <div className="join mt-4">
          {totalPages.map((page) => (
            <button
              key={page}
              className={`join-item btn ${currentPage + 1 === page ? "btn-active" : ""}`}
              onClick={() => setCurrentPage(page - 1)}
            >
              {page}
            </button>
          ))}
        </div>
      </div>
    </div>
  );
};
